import styled, { css } from "styled-components"
import { useLogEvent } from "../hooks/useLogEvent"
import { colors, device } from "../styles/stylesConfig"

const Container = styled.section`
    width: 100%;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    position: relative;
    background-color: ${colors.primary};

`

const Content = styled.div`
    width: 90%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin: 10vh 0rem;

    @media ${device.lg} {
        margin: 5vh 0rem;
    }

    @media ${device.md} {
        width: 80%;
        flex-direction: column;
    }
`

const ButtonsContainer = styled.div`
    width: 49%;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;

    @media ${device.md} {
        width: 100%;
        align-items: center;
    }
`

const Button = styled.a`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    margin-bottom: 20px;

    @media ${device.md} {
        align-items: center;
    }

    & > img {
        height: 24px;
        width: 24px;
    }

    & > h3 {
        color: #fff;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 1.4px;
        text-decoration-line: underline;

        @media ${device.md} {
             font-size: 12px;
            text-align: center;
        }
        
    }

`

const Maps = styled.iframe`
    width: 49%;
    height: 30rem;
    border: 1px solid #E2E2E2;
    box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.75);

    @media ${device.md} {
        width: 100%;
        align-items: center;
        margin-top: 20px;
    }

    @media ${device.sm} {
        height: 20rem;
    }

`

const Label = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 3rem;

    &:last-of-type {
        margin-top: 5rem;

        @media ${device.md} {
            margin-top: 0rem;
        }
    }

    & > img {
        width: 5rem;
        height: 5rem;

        @media ${device.md} {
            width: 3rem;
            height: 3rem;
        }
    }

    & > h3 {
        color: #fff;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 10px;
        padding-left: 2rem;

        @media ${device.lg} {
            font-size: 16px;
        }

        @media ${device.md} {
            font-size: 12px;
        }

        @media ${device.sm} {
            font-size: 12px;
        }
    
    }

`

const Target = styled.div`
    height: 0px;
    width: 0px;
    position: absolute;
    top: -12vh;
    left: 0px;

    @media ${device.md} {
        top: -20vh;
    }

`

const SocialContainer = styled.div<{ img: string }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 50px;
    position: relative;

    ${({ img }) => img && css`
        background: url(${img}) bottom no-repeat;
        background-size: cover;
    `}
    
    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.2); 
        z-index: 0;
    }


    & > h1 {
        color: #222;
        font-size: 60px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 6.8px;
        margin-bottom: 15px;


        @media ${device.md} {
            font-size: 60px;
        }

        @media ${device.sm} {
            font-size: 40px;
        }
    }

    & > h2 {
        color: #222;
        font-size: 12px;
        font-weight: 500;
        font-style: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        text-transform: uppercase;

        @media ${device.sm} {
            font-size: 12px;
        }
    }


`

const SocialButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 55px;

    @media ${device.sm} {
        flex-direction: column;
        gap: 20px;
    }

`

const SocialButton = styled.a`
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 15px;
    padding-right: 15px;

    &:nth-child(1) {
        border-right: solid 1px #222;

        @media ${device.sm} {
            border-right: unset;
        }

    }

    @media ${device.sm} {
        width: 85px;
        padding-left: 20px;
        padding-right: 20px;
    }

    & > img {
        height: 16px;
        width: 16px;
    }

    & > h3 {
        color: #000;
        font-size: 13px;
        font-weight: 500;
        font-style: normal;
        line-height: normal;
        letter-spacing: 3.9px;
        text-transform: uppercase;
        margin-left: 10px;

        @media ${device.sm} {
            font-size: 12px;
            letter-spacing: 1px;
            margin-left: 10px;
        }
    }


`


export const Footer = () => {

    const { handleLogEvent } = useLogEvent()

    return (

        <Container>

            <Target id="social" />

            <SocialContainer
                img={require('../images/social.png')}
            >

                <h1 className='utils__fade-in-fast-top'>Social</h1>

                <h2 className='utils__fade-in-fast-top'>Nuestras redes</h2>

                <SocialButtonsContainer className='utils__fade-in-fast-top'>

                    <SocialButton
                        className='social__button utils__fade-in-fast-top'
                        href="https://www.facebook.com/profile.php?id=61568191598037"
                        target='_blank'
                        rel="noreferrer"
                        onClick={() => {
                            handleLogEvent('Click_boton_facebook');
                        }}
                    >

                        <img
                            src={require('../images/facebook.png')}
                            alt='Logo 1'
                        />

                        <h3>Facebook</h3>

                    </SocialButton>

                    <SocialButton
                        className='social__button utils__fade-in-fast-top'
                        href="https://www.instagram.com/d.v_bombas/"
                        target='_blank'
                        rel="noreferrer"
                        onClick={() => {
                            handleLogEvent('Click_boton_correo');
                        }}
                    >

                        <img
                            src={require('../images/instagram.png')}
                            alt='Logo 2'
                        />

                        <h3>Instagram</h3>

                    </SocialButton>

                </SocialButtonsContainer>

            </SocialContainer>

            <Content>

                <ButtonsContainer>

                    <Label className='utils__fade-in-fast-top'>

                        <img
                            src={require('../images/ubicacion.webp')}
                            alt='Logo 1'
                        />

                        <h3>UBICACIÓN</h3>

                    </Label>

                    <Button className='utils__fade-in-fast-top'
                        href="https://maps.app.goo.gl/ApRRFBS9CJzsMaz77"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => {
                            handleLogEvent('Click_boton_ubicacion');
                        }}
                    >

                        <h3>Av. Jorge Newbery 204, Chivilcoy</h3>

                    </Button>

                    <Label className='utils__fade-in-fast-top'>

                        <img
                            src={require('../images/telefono.webp')}
                            alt='Logo 1'
                        />

                        <h3>CONTACTOS</h3>

                    </Label>

                    <Button
                        className='utils__fade-in-fast-top'
                        href="tel:+5492346339913"
                        onClick={() => {
                            handleLogEvent('Click_boton_primer_telefono');
                        }}
                    >

                        <h3>+54 9 2346339913 (Local)</h3>

                    </Button>

                    <Button
                        className='utils__fade-in-fast-top'
                        href="tel:+5492346525236"
                        onClick={() => {
                            handleLogEvent('Click_boton_segundo_telefono');
                        }}
                    >

                        <h3>+54 9 2346525236 (Ventas)</h3>

                    </Button>

                    <Button
                        className='utils__fade-in-fast-top'
                        href="tel:+5492227553712"
                        onClick={() => {
                            handleLogEvent('Click_boton_tercer_telefono');
                        }}
                    >

                        <h3>+54 9 2227553712 (Servicio técnico)</h3>

                    </Button>

                </ButtonsContainer>

                <Maps
                    className="utils__fade-in-fast-top"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.957447133144!2d-60.0010466232662!3d-34.90751737360761!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bea51e6da4071f%3A0x740f0dd6a96dca66!2sAv.%20Jorge%20Newbery%20204%2C%20Chivilcoy%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1740021440280!5m2!1ses!2sar"
                    loading="lazy" />

            </Content>


        </Container>

    )
}
